import { useUserPlanManager } from '@/shared/plan';
import { type MapTemplate } from '@/types';

export const useMapTemplateValidation = (
  mapTemplatedId: string,
  mapTemplates: MapTemplate[],
) => {
  const { userPlanManager } = useUserPlanManager();
  const mapTemplate = mapTemplates.find(t => t.templateId === mapTemplatedId);
  if (!mapTemplate) return false;
  return userPlanManager.hasEnoughPlanType(mapTemplate.templatePlanType);
};
